import React, { Component, Fragment } from "react";
import { Route, Routes } from "react-router-dom";

import Main from "./Main/Main";
import Item from "./Item/Item";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Checkout from "./Checkout/Checkout";
import withRouter from "./withRouter/withRouter";
import Loading from "./Loading/Loading";
import Pay from "./Pay/Pay";
import Search from "./Search/Search";
import Toast from "./Toast/Toast";
import Costumer from "./Costumer/Costumer";
import FollowUp from "./FollowUp/FollowUp";
import About from "./About/About";
import Rules from "./Rules/Rules";

import "./App.css";
import "../fontawesome/css/all.css";

class App extends Component {
    constructor(props) {
        super(props);

        this.validateToken = this.validateToken.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.deleteFromCart = this.deleteFromCart.bind(this);
        this.not_signedUser = this.not_signedUser.bind(this);
        this.clear_cart = this.clear_cart.bind(this);

        this.logout = this.logout.bind(this);
    }

    componentDidMount() {
        let { connection } = this.props;

        connection
            .get_contact_info()
            .then((res) => {
                this.setState({ contact_info: res.data });
            })
            .catch((err) => {});

        this.validateToken();
    }

    validateToken(onDone) {
        let { connection, router } = this.props;
        let cookieMobile = localStorage.getItem("mobile");
        let cookieToken = localStorage.getItem("token");

        if (cookieMobile && cookieToken) {
            //validate token
            connection
                .validateToken(cookieMobile, cookieToken)
                .then((res) => {
                    localStorage.setItem("mobile", cookieMobile);
                    localStorage.setItem("token", cookieToken);
                    // if (!res.data.numberVerified) {
                    //     router.navigate(
                    //         "/verify-number/verify" +
                    //             router.location.pathname.replace(
                    //                 "/verify-number/verify",
                    //                 ""
                    //             ) +
                    //             router.location.search
                    //     );
                    //     return;
                    // }

                    connection
                        .get_costumer(res.data.mobile)
                        .then((res) => {
                            let { costumer } = res.data;
                            costumer.signed = true;

                            localStorage.removeItem("costumer");
                            this.setState({ costumer, ready: true });
                            clearInterval(this.vaildateInterval);
                        })
                        .catch((err) => {
                            this.toast(
                                "اطلاعات کاربر",
                                "خطا در دریافت اطلاعات کاربر" + err,
                                " danger"
                            );
                        })
                        .finally(() => {
                            this.setState({ ready: true });
                        });
                })
                .catch((err) => {
                    console.log(err);
                    localStorage.removeItem("mobile");
                    localStorage.removeItem("token");
                    this.toast(
                        "اعتبارسنجی",
                        "مدت اعتبار کلید شما منقضی شده است.\nلطفا مجددا وارد شوید",
                        " warning"
                    );
                    clearInterval(this.vaildateInterval);
                    this.not_signedUser();
                });
        } else {
            this.not_signedUser();
        }
    }

    not_signedUser() {
        let costumer = localStorage.getItem("costumer");
        try {
            costumer = JSON.parse(costumer);
            if (!costumer) throw new Error();
        } catch (e) {
            localStorage.setItem(
                "costumer",
                JSON.stringify(this.state.costumer)
            );
            costumer = this.state.costumer;
        }
        this.setState({ costumer, ready: true });
    }

    async addToCart(item, color, amount) {
        let { costumer } = this.state;
        let { id, name, medias, unit } = item;
        let thumbnail = medias.find((m) => {
            return m.type === "image";
        });

        if (costumer) {
            if (costumer.signed) {
                try {
                    let { data } = await this.props.connection.get_costumer(
                        costumer.mobile
                    );

                    costumer = data.costumer;
                    costumer.signed = true;

                    this.setState({ costumer, ready: true });
                } catch (err) {
                    this.toast(
                        "اطلاعات کاربر",
                        "خطا در دریافت اطلاعات کاربر" + err,
                        " danger"
                    );
                }
            } else {
                costumer = localStorage.getItem("costumer");
                try {
                    costumer = JSON.parse(costumer);
                    if (!costumer) throw new Error();
                } catch (e) {
                    localStorage.setItem(
                        "costumer",
                        JSON.stringify(this.state.costumer)
                    );
                    costumer = this.state.costumer;
                }
                console.log(costumer)
            }

            let order = {
                id,
                name,
                thumbnail,
                amount,
                color: color.color,
                unit,
            };
            let { cart } = costumer;
            console.log(cart);
            let prev_cart = cart && cart.length > 0 ? [...cart] : [];
            const prevItemInCartIndex =
                cart && cart.length > 0
                    ? cart.findIndex((i) => {
                          return (
                              i.id === order.id &&
                              order.color.color === i.color.color
                          );
                      })
                    : -1;

            cart && cart.length > 0
                ? prevItemInCartIndex > -1
                    ? (cart[prevItemInCartIndex].amount =
                          parseFloat(cart[prevItemInCartIndex].amount) +
                          parseFloat(amount))
                    : cart.push(order)
                : (cart = [order]);

            this.updateCart(costumer, cart, prev_cart);
        }
    }

    logout() {
        let { connection } = this.props;

        localStorage.removeItem("mobile");
        localStorage.removeItem("token");
        connection
            .log_out()
            .then((res) => {
                this.setState({ costumer: { signed: false, cart: [] } });
                window.location.reload();
            })
            .catch(console.log);
    }

    deleteFromCart(index) {
        let { costumer } = this.state;

        if (costumer) {
            let { cart } = costumer;
            let prev_cart = cart && cart.length > 0 ? [...cart] : [];

            cart && index < cart.length && cart.splice(index, 1);
            this.updateCart(costumer, cart, prev_cart);
        }
    }

    updateCart(costumer, cart, prevCart) {
        let { connection } = this.props;

        costumer.cart = cart;
        this.setState({ costumer });

        if (costumer.signed) {
            connection
                .update_cart({ cart })
                .then((res) => {
                    this.toast(
                        "بروز رسانی سبد خرید",
                        "سبد خرید شما بروز شد",
                        " confirm"
                    );
                })
                .catch((err) => {
                    this.toast(
                        "بروز رسانی سبد خرید",
                        "  : خطا در بروز رسانی سبد خرید" + err,
                        " danger"
                    );

                    costumer.cart = prevCart;
                    this.setState({ costumer: costumer });
                });
        } else {
            localStorage.setItem("costumer", JSON.stringify(costumer));
        }
    }

    clear_cart() {
        let { costumer, cart } = this.state;

        this.updateCart(costumer, [], cart);
    }

    state = {
        creds: null,
        costumer: { cart: [], signed: false },
        ready: false,
        contact_info: null,
    };
    render() {
        let { connection } = this.props;

        let { costumer, ready, contact_info } = this.state;
        let showSearch =
            !this.props.router.location.pathname.includes("/search");
        return (
            <Fragment>
                <Header
                    costumer={costumer}
                    deleteFromCart={this.deleteFromCart}
                    showSearch={showSearch}
                    logout={this.logout}
                ></Header>

                <Toast
                    setToastHook={(cb) => {
                        this.toast = cb;
                    }}
                />

                {ready ? (
                    <Routes>
                        <Route path='' element={<Main toast={this.toast} />} />
                        <Route
                            path='/checkout'
                            element={
                                <Checkout
                                    toast={this.toast}
                                    connection={connection}
                                    deleteFromCart={this.deleteFromCart}
                                    clear_cart={this.clear_cart}
                                    cart={costumer.cart}
                                />
                            }
                        />
                        <Route
                            path='/item/:id'
                            element={
                                <Item
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                    addToCart={this.addToCart}
                                />
                            }
                        />

                        <Route
                            path='/pay/:method'
                            element={
                                <Pay
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />

                        <Route
                            path='/pay/:method/:id/'
                            element={
                                <Pay
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />

                        <Route
                            path='/pay/:method/:id/:mobile'
                            element={
                                <Pay
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />
                        <Route
                            path='/search/'
                            element={
                                <Search
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />

                        <Route
                            path='/costumer/*'
                            element={
                                <Costumer
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                    deleteFromCart={this.deleteFromCart}
                                    clear_cart={this.clear_cart}
                                />
                            }
                        />

                        <Route
                            path='/follow-up/'
                            element={
                                <FollowUp
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />

                        <Route
                            path='/follow-up/:id'
                            element={
                                <FollowUp
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />
                        <Route
                            path='/about-us'
                            element={<About contact_info={contact_info} />}
                        />
                        <Route path='/rules' element={<Rules />} />

                        <Route path='*' element={<Main toast={this.toast} />} />
                    </Routes>
                ) : (
                    <Loading />
                )}

                <footer>
                    <Footer contact_info={contact_info} />
                </footer>
            </Fragment>
        );
    }
}

export default withRouter(App);
